import React, { Fragment, useEffect } from 'react';
import { SRow, SCol } from '@avalara/skylab-sdk/react';
import styled from 'styled-components';
import ThankYouBanner from './banner';
import InformationYouNeed from './information-you-need';
import Resources from '../../shared/resources';
import { emailLinkText, content, } from '../constants';
const SetUp = styled.h2 `
  max-width: 760px;
`;
const ThankYou = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (React.createElement(Fragment, null,
        React.createElement(ThankYouBanner, { role: 'complementary' }),
        React.createElement("div", { className: 'flex justify-content-center text-center align-items-center', role: 'main' },
            React.createElement(SRow, null,
                React.createElement(SCol, { span: '12', className: 'pad-top-lg pad-bottom-lg' },
                    React.createElement(SetUp, null, emailLinkText)))),
        React.createElement(InformationYouNeed, null),
        React.createElement(Resources, { content: content })));
};
export default ThankYou;
